import './css/App.css';
import Banner from './components/Banner';
import Languages from './components/Languages';
import Experience from './components/Experience';
import Certifications from './components/Certifications';
import LatestWork from './components/Latest-work';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Banner/>
      <Languages/>
      <Experience/>
      
      <Certifications/>
      <LatestWork/>
      <Footer/>
    </div>
  );
}

export default App;
